import { Component, OnInit } from '@angular/core';
import { GridColumnsConfiguration, GridFilter } from '../../shared/grid/grid.component';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ModalReportingFieldsComponent } from './modal-reporting-fields/modal-reporting-fields.component';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { GridServiceService } from 'src/app/services/shared/grid-service.service';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/security/login.service';

@Component({
  selector: 'neoris-device-management',
  templateUrl: './device-management.component.html',
  styleUrls: ['./device-management.component.css']
})
export class DeviceManagementComponent implements OnInit {
  search:string=''
  public iconColumn: string = "incidentStatus"
  arrayGirdDeviceManagement: any[] = []
  arrayGirdDeviceManagementGrid: any[] = []
  public gFilter: GridFilter = undefined;
  private onLanChange:Subscription
  languaje:string=''
  private gridServiceServiceSubscription:Subscription
  rowSelectedCctv:any
  private onIsAllSitesSubscription:Subscription
  


  constructor(private dialog: MatDialog,
    private route: Router,
    private controltowerservice:ControltowerService
    ,private translate:TranslateService,
    private gridServiceService: GridServiceService,
    private _snackBar:MatSnackBar,
  private propertiesService:PropertiesTowers,
  private securityService: LoginService) { }


    public gridColumnsConfiguration: GridColumnsConfiguration = {
      IconValue: "summary",
      IconColumnName: "summary",
      hiddenColumnNames: ["sourceDeviceId", "siteId", "ROW_ID"],
      dateColumns: [
        {columnName: "LastConnection"},
        {columnName: "LastEvent"}
      ],
      cardColum: "Name",
      cardValues: [
        { place: 0, nombre: 'Name', isMainColumn: false },
        { place: 0, nombre: 'Type', isMainColumn: false },
        { place: 0, nombre: 'Location', isMainColumn: false },
        { place: 0, nombre: 'Site', isMainColumn: false },
        { place: 0, nombre: 'LastConnection', isMainColumn: false },
        { place: 0, nombre: 'ConnectionStatus', isMainColumn: false },
        { place: 0, nombre: 'LastEvent', isMainColumn: false },
        { place: 0, nombre: 'visibility', isMainColumn: false },
        { place: 0, nombre: 'summary', isMainColumn: false }
      ],
      listColumns:[],
      MultiIconColumns:[],
      ActionColumn: {
        ColumnName: "",
        Actions: [
        ]
    }
  }


  private fromStatusCCTV: boolean = true

  async ngOnInit(): Promise<void> {

    console.log("DeviceManagementComponent")

    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const guid = JSON.parse(localStorage.getItem('guidSession'))
    const response = await this.securityService.login(userName,guid).toPromise()
    
    this.rowSelectedCctv = JSON.parse(localStorage.getItem('rowSelectEventCctv'))

    this.gridServiceServiceSubscription = this.gridServiceService.recieveSelectedRowsObservable.subscribe(selectedData => {
      console.log("SelectedGridData", selectedData)
      localStorage.setItem('SelectedGridData',JSON.stringify(selectedData))
      if(selectedData.length > 0){
        this.openDialog()
      }
      else{
        
        this.openSnackBar(this.translate.instant('TEXT_VALIDATION_RECORD_DEVICE_MANAGEMENT'),"Error")
      }
    })

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.languaje = s.lang != undefined ? s.lang : "en";
      let successDeviceManagement = this.getDevicesManagement(this.languaje,this.rowSelectedCctv.id)
    })

   

    this.onIsAllSitesSubscription =this.propertiesService.IsSelectAllSites$.subscribe((value) =>{

     
      if(this.fromStatusCCTV == true){
        let successDeviceManagement = this.getDevicesManagement('en',this.rowSelectedCctv.id)
        this.fromStatusCCTV  = false
      }
      else{
        let siteId = localStorage.getItem('site');
        let successDeviceManagement = this.getDevicesManagement('en', siteId)
      }
      
    })



   


  }

  public cellClick(obj: any) {
    localStorage.setItem('rowSelectDevice',JSON.stringify(obj))
    this.route.navigate(['/devices-availability'])
  }

  getSearchFiltr(event: any){
    console.log('key:',event)

    const filterValue = (event.target as HTMLInputElement).value;


    const gridFilter: GridFilter = {
      importance: 1,
      column: "Name",
      filter_one: filterValue,
      isFilterDates: false,
      isExternalFilter: true
    }

    console.log("gridFilter", gridFilter)

    this.gFilter = gridFilter
  }

  checkSelection(){
    this.gridServiceService.requestSelectedRows()
  }

  openDialog(): void {

    
    this.dialog.open(ModalReportingFieldsComponent,
      {
        restoreFocus: false,
        width: '500px'
    });

    this.gridServiceService.clearSelectedRows()
  }


  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }

  ngOnDestroy():void{

    this.onLanChange.unsubscribe()
    this.gridServiceServiceSubscription.unsubscribe()
   
  }

  private async getDevicesManagement(lang:string,siteId:string): Promise<boolean> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getDeviceManagement(lang,siteId).subscribe(
        {
          next: (arraydevices: any={}) => {

            console.log("arraydevices------>", arraydevices)
            this.fillDataDeviceManagement(arraydevices)

          
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async fillDataDeviceManagement(devices:any={}){
    this.arrayGirdDeviceManagement = []
    console.log("devices",devices)
    devices.sites.forEach(row => {    
      row.devices.forEach(device => {

          console.log("device",device)  

          let pingDt = device.sourceDeviceStatusCurrent.pingDT == undefined ? '' : device.sourceDeviceStatusCurrent.pingDT
          let lastEvent = device.sourceDeviceStatusCurrent.lastEvent == undefined ? '' : device.sourceDeviceStatusCurrent.lastEvent
          let connectionStatus = device.sourceDeviceStatusCurrent.connectionStatus == undefined ? '' : device.sourceDeviceStatusCurrent.connectionStatus
          let visibility = device.sourceDeviceStatusCurrent.visibilityPercentage == undefined ? '' : device.sourceDeviceStatusCurrent.visibilityPercentage
          let summary = device.sourceDeviceStatusCurrent.summary == undefined ? '' : device.sourceDeviceStatusCurrent.summary
  
  
          if(visibility !== ''){
  
            if(visibility > 0){
              visibility = (parseFloat(visibility.toString()) * 100).toFixed(2) + '%'
            }else{
              visibility = ''
            }
          }
  
  
          this.arrayGirdDeviceManagement.push(
            {
              ROW_ID: this.arrayGirdDeviceManagement.length + 1,
              isNew: false,
              Name:device.sourceDevice.name,
              Type:device.deviceType.name,
              Location:device.location.name, 
              siteId: row.site.id, 
              Site:  row.site.name,
              sourceDeviceId:device.sourceDevice.id,
              LastConnection:pingDt,
              LastEvent:lastEvent,
              ConnectionStatus:connectionStatus,
              visibility:visibility,
              summary:summary
            }) 
      });
    })

    this.arrayGirdDeviceManagementGrid = this.arrayGirdDeviceManagement


  }

}
